import { createUseStyles } from "react-jss";
import { colors } from "../../../styles/colors";
const useStyles = createUseStyles((_) => ({
  contentMain: {
    overflow: "hidden",
    height: "var(--app-vh)",
  },
  vehiculeRoot: {
    overflowY: "auto",
    padding: "20px clamp(16px, 3vw, 30px)",
    height: "var(--app-vh)",
    backgroundColor: colors.bgcolor,
    "@media (max-width:899.95px)": { paddingTop: "68px" },
  },
  container: {
    "@media (max-width:899.95px)": { width: "100%" },
    display: "flex",
    flexDirection: "column",
    gap: "30px",
  },
  containerHeader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "94px",
    justifyContent: "space-between",
    // maxWidth: 1275,
    width: "100%",
    "@media (max-width:899.95px)": {
      gap: "16px",
      flexWrap: "wrap",
    },
  },
  subContainer: {
    display: "flex",
    flexDirection: "row",
    gap: 15,
    height: "calc(var(--app-vh) - 140px)",
    overflow: "auto",
    "@media (max-width: 1024px)": {
      flexDirection: "column",
      height: "auto",
      overflow: "visible",
    },
  },
  iconContainerHeader: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  leftContent: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    width: "100%",
  },
  containerBodyLeft: {
    display: "flex",
    flexDirection: "row",
    gap: "15px",
    "@media (max-width:899.95px)": {
      flexDirection: "column",
    },
  },
  divClaims: {
    width: "100%",
  },
  rightContent: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    "@media (max-width: 1024px)": {
      width: "100%",
    },
  },

  textModalContainer: {
    padding: "0px 0px 29px 0px",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },

  divDocument: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
}));

export default useStyles;
